import { render, staticRenderFns } from "./OtherLabourDetail.vue?vue&type=template&id=6af2cd9b&scoped=true"
import script from "./OtherLabourDetail.vue?vue&type=script&lang=js"
export * from "./OtherLabourDetail.vue?vue&type=script&lang=js"
import style0 from "./OtherLabourDetail.vue?vue&type=style&index=0&id=6af2cd9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af2cd9b",
  null
  
)

export default component.exports